import { render, staticRenderFns } from "./UtilityPatients.vue?vue&type=template&id=3503d80e&"
import script from "./UtilityPatients.vue?vue&type=script&lang=js&"
export * from "./UtilityPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports